import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//课程列表
export const getCourse = data => http.get('/mini/Course', data);

//课程详情
export const getCourseDetail = data => http.get('/mini/Course/'+ data.uuid);

//课程分类
export const getCourseCate = data => http.get('/mini/CourseCate', data);

//新增收藏
export const addCollect = data => http.post('/mini/Collect', data);

//取消收藏
export const delCollect = data => http.delete('/mini/Collect/'+ data.uuid);

//收藏列表
export const getCollect = data => http.get('/mini/Collect');

//评价
export const getCourseOrderEvaluate = data => http.get('/mini/CourseOrderEvaluate',data);
//下单
export const buyCourseOrder = data => http.post('/mini/CourseOrder', data);

//我的课程章节
export const getUserChapter = data => http.get('/mini/UserChapter?course_uuid='+data.course_uuid, data);

//我的课程订单列表
export const getCourseOrder = data => http.get('/mini/CourseOrder?course_uuid='+data.course_uuid, data);

//新增评价
export const addCourseOrderEvaluate = data => http.post('/mini/CourseOrderEvaluate', data);


//章节详情
export const getChapterDetail = data => http.get('/mini/Chapter/'+data.uuid, data);

//章节学习进度保存
export const putUserChapter = data => http.put('/mini/UserChapter/'+data.uuid,data);

//评价点赞
export const CourseOrderEvaluateAgree = data => http.post('/mini/CourseOrderEvaluateAgree',data);